export default "__VITE_PUBLIC_ASSET__a27a0596__"